export default {
  get: function(){
    return{
      sending:false,
      success: false
    }
  }
}
